var render = function render(){var _vm=this,_c=_vm._self._c;return _c('LinkCard',{staticClass:"theme-card",class:{
    'theme-card--active': _vm.active,
    'theme-card--shrink': !Boolean(_vm.value.description),
    'theme-card--disabled': _vm.disabled,
  },attrs:{"theme":"light","image":_vm.thumbnail,"icon":['fal', 'palette'],"disabled":_vm.disabled},nativeOn:{"click":function($event){_vm.disabled ? {} : _vm.$emit('select', _vm.value.value)}},scopedSlots:_vm._u([{key:"title",fn:function(){return [_c('h3',[_vm._v(_vm._s(_vm.value.label))]),_c('div',[_vm._v(_vm._s(_vm.$t(_vm.value.description)))])]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }